import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export type SlackAlertType = "down" | "up";

export interface SlackSectionToggles {
  monitored_url: boolean;
  tags: boolean;
  more_info_links: boolean;
  realtime_analysis: boolean;
  additional_details: boolean;
}

export type SlackCustomizationState = Record<SlackAlertType, SlackSectionToggles>;

export const SLACK_SECTION_KEYS: Array<keyof SlackSectionToggles> = [
  "monitored_url",
  "tags",
  "more_info_links",
  "realtime_analysis",
  "additional_details",
];

export const SLACK_SECTION_LABELS: Record<keyof SlackSectionToggles, {label: string; description?: string}> = {
  monitored_url: {
    label: "Monitored URL",
  },
  tags: {
    label: "Tags",
    description: "Monitor tags such as prod, api, payments. Useful for triage routing.",
  },
  more_info_links: {
    label: "More info links",
    description: "Links to the check dashboard, incident history and on-call escalation page on Uptime.com.",
  },
  realtime_analysis: {
    label: "Real-time analysis links",
    description: "Shortcut to run a real-time probe and traceroute against the failing target.",
  },
  additional_details: {
    label: "Additional details",
    description: "Probe location, response time, status code, error reason and incident ID.",
  },
};

export const DEFAULT_SLACK_CUSTOMIZATION: SlackCustomizationState = {
  down: {
    monitored_url: true,
    tags: true,
    more_info_links: true,
    realtime_analysis: true,
    additional_details: true,
  },
  up: {
    monitored_url: true,
    tags: false,
    more_info_links: false,
    realtime_analysis: false,
    additional_details: false,
  },
};

export const SlackShape = {
  webhook_url: Yup.string().label("Webhook URL").url().required(),
  channel: Yup.string().label("Channel").required(),
  message_customization: Yup.mixed<SlackCustomizationState>().optional(),
};

export interface SlackInput {
  webhook_url: string;
  channel: string;
  message_customization?: SlackCustomizationState;
}

yupResolver<SlackInput>(Yup.object().shape(SlackShape));
